import React, { FC } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';

import type { ImageWrapperProps } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/ImageWrapper';
import { useManageThumbnailNavButton } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/ThumbnailNavButton/hooks/useManageThumbnailNavButton';

export interface ThumbnailNavButtonProps extends Pick<ImageWrapperProps, 'documentRetrieveKey' | 'documentRetrieveId'> {
  scale?: ScaleFunction;
}

export const ThumbnailNavButton: FC<ThumbnailNavButtonProps> = (props) => {
  const { scale = initialScale } = props;
  const { onPress } = useManageThumbnailNavButton(props);

  return (
    <TouchableElement onPress={onPress}>
      {({ pressHoverColor, boxStyle }) => (
        <View style={[boxStyle, { padding: scale(20) }]}>
          <Svg icon="squares" color={pressHoverColor('Button/Light/Primary')} width={scale(20)} height={scale(20)} />
        </View>
      )}
    </TouchableElement>
  );
};
